import PropTypes from 'prop-types';
// @mui
import { Box, Stack, Typography } from '@mui/material';
// components
import CustomModal from '../../../components/CustomModal';
import { GoldBorderButton } from '../../../components/nav-section/vertical/style';
import useLocales from '../../../hooks/useLocales';

// ----------------------------------------------------------------------

const DetailRow = ({ label, value }) => (
  <Stack direction="row" spacing={2} sx={{ justifyContent: 'space-between', alignItems: 'baseline' }}>
    <Typography variant="body2" sx={{ color: '#c9c9c9', whiteSpace: 'nowrap' }}>
      {label}
    </Typography>
    <Typography variant="subtitle2" fontWeight={900} sx={{ color: 'white', textAlign: 'right', wordBreak: 'break-all' }}>
      {value || '-'}
    </Typography>
  </Stack>
);

DetailRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};

// ----------------------------------------------------------------------

export default function RegisterSuccessDialog({ open, details, onConfirm }) {
  const { translate } = useLocales();

  return (
    <CustomModal
      maxWidth="xs"
      open={open}
      hasClose={false}
      isBackdropClosable={false}
      onClose={onConfirm}
      paperPropsSx={{ p: 1 }}
    >
      <Box sx={{ p: 3 }}>
        <Stack spacing={1} sx={{ alignItems: 'center', mb: 3 }}>
          <Typography className="gold-text" variant="h6" fontWeight={900} sx={{ textAlign: 'center' }}>
            {translate('registration_successful')}
          </Typography>
          <Typography variant="caption" sx={{ color: '#c9c9c9', textAlign: 'center' }}>
            {translate('please_keep_your_details')}
          </Typography>
        </Stack>

        <Stack spacing={1.5}>
          <DetailRow label="ID:" value={details?.username} />
          <DetailRow label={`${translate('password')}:`} value={details?.password} />
          <DetailRow label={`${translate('bank')}:`} value={details?.bankName} />
          <DetailRow label={`${translate('bank_acc_name')}:`} value={details?.bankAccountName} />
          <DetailRow label={`${translate('bank_acc_number')}:`} value={details?.bankAccountNumber} />
        </Stack>

        <GoldBorderButton fullWidth size="large" onClick={onConfirm} sx={{ mt: 4 }}>
          <Typography className="gold-text" fontWeight={900}>
            {translate('confirm')}
          </Typography>
        </GoldBorderButton>
      </Box>
    </CustomModal>
  );
}

RegisterSuccessDialog.propTypes = {
  open: PropTypes.bool,
  details: PropTypes.object,
  onConfirm: PropTypes.func,
};
